var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 28,
    viewBox: "0 0 17 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 28,
    width: 17,
    height: 28,
    transform: "rotate(-180 17 28)",
    fill: "url(#pattern0)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(0 -0.00595238) scale(0.0277778 0.0168651)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 36,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAA8CAYAAAAOhRhuAAACSklEQVRoBd3awWrCQBAGYB+tT1booSezERERERExu6uI+AB2swM99NBH6AP00FOfwDIboxvBotM/slSQrLbdfM6aZGbSTueOj+7CPyjrB6ooP5UtP7KCnvi9OxJOuwoY47bKlPvG0/rB3VG8w9zSpgGJYdbN7oaqMG59EXOAZcbZ1lHXYo7Ype+dFhk8YkxW0Oq4s3iJLo/fwYxqOiFmn5lyBwcFjHH2xsiEIy9fvjxCQYxRmrQEowwp/nsYKGAKt0gHY2guwix9Dx8ZKUZTH4+xbiaKDPqSEb4zQkxW0LCFyNBUEpl2MMZNRBjtR/jICDG5pTEcw5NKIqOMm8AxmfYjEcbS9J9jChrKIgPOAjnMfIiKMIbm8GUK1cHlRKqZqMe/V7gFHqOpL4qMJo3HLH1PgoEn6fzJOEkSYQpa4SOTFEb7riQyuXVraGQ4f+X6WoahDRzDIGXLt9tBbtsKJkTIlLukQFwL3Q4q99w8aCVKPKlK6UvNyxZQqRz2DOLHn1BttVICKpVLxyFQVaRSubg2UNycjNOKa8fo9CNGJZOgpY8SVxzgvLoRKTEKXAbFqGQKxRjFVajk6IOX0ggUV7988q3ngm3DGd0m0o6pP1WFSqR71kBJ+4volh4EhW56NlDSHjW6LQxBobv4DVQqtxZiFNf5kpMn14j1PNAtnxIE98r2XCNCIfFkQtRrPAd8zCiu/69ePu27cMT5hNei4P2lc0j8ukL9dpu8pZwpRpyPGaVS+UeCGneI1FgZ+lam/MotPfN79c95+wOznixNgftolAAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.826c6269.svg";
export { ForwardRef as ReactComponent };